<template>
    <div>
        <nav class="navbar has-shadow" role="navigation" aria-label="main navigation">
            <div class="container">
                
                <div class="navbar-brand">
                    <a class="navbar-item" href="">
                        <img src="/static/logo.png" alt="VeggieFactory logo" width="150" height="50">
                    </a>
                    <div class="navbar-burger" @click="showNav = !showNav" :class="{ 'is-active': showNav }">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <div class="navbar-menu" :class="{ 'is-active': showNav }">
                    <div class="navbar-end">
                        <router-link class="navbar-item" activeClass="is-active"  to="/app/analytics">Analytics</router-link>
                        <!-- <router-link class="navbar-item" activeClass="is-active"  to="/app/hotels">Hotels</router-link> -->
                        <router-link class="navbar-item" activeClass="is-active"  to="/app/queries">Queries</router-link>
                        <router-link class="navbar-item" activeClass="is-active"  to="/app/bookings">Bookings</router-link>
                        <router-link class="navbar-item" activeClass="is-active"  to="/app/hotel">Hotels</router-link>
                        <router-link class="navbar-item" activeClass="is-active"  to="/app/users">Agents</router-link>
                        <router-link class="navbar-item" activeClass="is-active"  to="/app/configs">Configs</router-link>
                      
                       <b-dropdown position="is-bottom-left">
                    <a class="navbar-item" slot="trigger">
                        
                        <b-icon icon="bell" size="is-small"></b-icon>
                    </a>
<!-- 
                    <b-dropdown-item custom>
                     <strong>  Unread Queries </strong><b>  | <b-tag class="is-danger" rounded>2</b-tag></b>
                    </b-dropdown-item>
                    <hr class="dropdown-divider"> -->
                 
                    <b-dropdown-item value="home">
                    <strong>Coming Soon</strong>
                    </b-dropdown-item>
               <!--      <b-dropdown-item value="home">
                    <strong>Query No.</strong> : TRVLMQRY124
                    </b-dropdown-item> -->
                  
                </b-dropdown>
                          <div class="navbar-item has-dropdown is-hoverable ">
                            <router-link class="navbar-link is-arrowless" to="/app/profile "><img src="https://us.123rf.com/450wm/triken/triken1608/triken160800029/61320775-stock-vector-male-avatar-profile-picture-default-user-avatar-guest-avatar-simply-human-head-vector-illustration-i.jpg?ver=6" class="image is-32x32" style="border-radius: 50%;" > &nbsp; </router-link>
                            <div class="navbar-dropdown ">
                                  <router-link class="navbar-item" activeClass="is-active"  to="/app/cities">Profile</router-link>
                                  <a class="navbar-item"  @click="logout" >Logout</a>
                            
                                <!-- <router-link class="navbar-item" activeClass="is-active"  to="/app/categories">Categories</router-link>
                                <router-link class="navbar-item" activeClass="is-active"  to="/app/products">Products</router-link> -->
                            </div>
                        </div>
        
                        
       
                    </div>
                </div>
            </div>
        </nav>
        <div class="container main-container">
            <router-view />
        </div>
    </div>
</template>

<script>
import Firebase from '../../lib/Firebase';

export default {
  name: 'dashboard',
data(){
    return{
    showNav: false
    }
},
  computed: {
    showAnalytics() {
      return this.$route.path === '/app/analytics';
    }
  },

  methods: {
    logout() {
      Firebase.auth().signOut();
      this.$router.push('/');
    },

    toggleNav() {
      this.isNavOpen = !this.isNavOpen;
    }
  }
};

</script>

<style>
.main-container {
  margin-top: 2rem !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/Dashboard.vue